export const postAuthedStorefrontReviewQuery = `
mutation postCreateStorefrontReview(
    $content: String!,
    $memberId: ID,
    $id: ID!,
    $title: String,
    $ratings: [CreateReviewRatingInput!]!,
    $attributes: CreateReviewAttributesInput!,
    $source: CreateReviewSourceInput!,
    $recommended: Boolean!,
    $photos: [CreateReviewPhotoInput!]!
    $firstName: String,
    $lastName: String
) {
    createReview(
        input: {
        attributes: $attributes,
        content: $content,
        memberId: $memberId,
        ratings: $ratings,
        recommended: $recommended
        source: $source,
        storefrontId: $id,
        title: $title,
        photos: $photos
        firstName: $firstName,
        lastName: $lastName
    }) {
    review {
      id
    }
  }
}
	`;

export interface PostCreateStorefrontReviewVariables {
	content: string;
	memberId?: string;
	id: string;
	title?: string;
	ratings: CreateReviewRatingInput[];
	attributes: CreateReviewAttributesInput;
	source: Record<string, never>;
	recommended: boolean;
	photos: CreateReviewPhotoInput[];
	firstName?: string;
	lastName?: string;
}

export interface CreateReviewRatingInput {
	ratingId: string;
	value: number;
}

export interface CreateReviewAttributesInput {
	budgetGuestCount?: number;
	budgetCost?: number;
	weddingDate?: string;
}

export interface CreateReviewPhotoInput {
	sourceId: string;
	sortOrder: number;
	height: number | null;
	width: number | null;
}

export interface PostCreateStorefrontReviewResponse {
	createReview: {
		review: {
			id: string;
		};
	};
}
